import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function ProfileSkeleton() {
  return (
    <div className="min-h-screen bg-background pb-24">
      {/* Header with Avatar and Background */}
      <div className="relative">
        <Skeleton className="h-32 w-full rounded-none" /> {/* Header background */}
        <div className="absolute top-16 left-1/2 -translate-x-1/2">
          <Skeleton className="h-24 w-24 rounded-full border-4 border-background" />
        </div>
      </div>

      {/* User Info */}
      <div className="mt-16 text-center space-y-2 px-4">
        <Skeleton className="h-7 w-40 mx-auto" />
        <Skeleton className="h-5 w-32 mx-auto" />
        <div className="flex gap-2 justify-center mt-3">
          <Skeleton className="h-6 w-16 rounded-full" />
          <Skeleton className="h-6 w-16 rounded-full" />
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="mt-6 px-4">
        <div className="grid grid-cols-4 gap-2">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-10 rounded-lg" />
          ))}
        </div>
      </div>

      {/* Tab Content - Stats Grid */}
      <div className="mt-6 px-4 space-y-4">
        <div className="grid grid-cols-2 gap-3">
          {[1, 2, 3, 4].map((i) => (
            <Card key={i} className="p-4">
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-6 w-16" />
              </div>
            </Card>
          ))}
        </div>

        {/* Additional Content Cards */}
        {[1, 2].map((i) => (
          <Card key={i} className="p-4">
            <Skeleton className="h-32 w-full rounded-lg" />
          </Card>
        ))}
      </div>
    </div>
  );
}
